import { useModals } from 'almanac-ui/Modal'
import { MediaUploadModal } from 'blaze-components/MediaUploadModal/MediaUploadModal'
import { AddFromAnotherSourceButton } from 'components/Wizards/SelectImages/AddFromAnotherSourceButton'
import { DesktopAddFromAnotherSourceButtonProps } from 'components/Wizards/SelectImages/Types'

export const DesktopAddFromAnotherSourceButton = ({ onAdd, ...props }: DesktopAddFromAnotherSourceButtonProps) => {
  const { openModal, closeStack } = useModals()

  const handlePress = () => {
    openModal(
      MediaUploadModal,
      {
        onPressOutside: closeStack,
        accept: 'image/png, image/jpeg, image/gif',
        onCancel: closeStack,
        defaultProvider: 'uploads',
        handleSubmit: onAdd,
        step: 0,
        steps: [],
        title: 'Add From Another Source',
      },
      { newStack: true },
    )
  }

  return <AddFromAnotherSourceButton onPress={handlePress} size="md" variant="secondary" {...props} />
}
